import { Outlet, NavLink, useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Users, Package, FolderTree, Settings, LogOut, ExternalLink, Star, QrCode } from "lucide-react";

const LINKS = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/leads", label: "Leads / CRM", icon: Users },
  { to: "/admin/produtos", label: "Produtos", icon: Package },
  { to: "/admin/categorias", label: "Categorias", icon: FolderTree },
  { to: "/admin/prova-social", label: "Prova Social", icon: Star },
  { to: "/admin/pos-venda", label: "Pós-venda", icon: QrCode },
  { to: "/admin/config", label: "Configurações", icon: Settings },
];

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();

  if (loading) return <div className="flex min-h-screen items-center justify-center bg-[#0A0A0B] text-[#A1A1AA]">Carregando...</div>;
  if (!user) return <Navigate to="/admin/login" replace />;

  return (
    <div className="flex min-h-screen bg-[#0A0A0B]">
      <aside className="hidden w-60 shrink-0 flex-col border-r border-[#27272A] bg-[#0A0A0B] md:flex">
        <div className="border-b border-[#27272A] p-5">
          <div className="font-heading text-lg font-black text-white">GLOBAL</div>
          <div className="text-[0.6rem] uppercase tracking-widest text-[#A1A1AA]">Admin</div>
        </div>
        <nav className="flex-1 p-3">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} data-testid={`admin-nav-${l.label}`}
              className={({ isActive }) => `mb-1 flex items-center gap-3 px-3 py-2.5 text-sm font-medium transition-colors duration-200 ${isActive ? "bg-[#FF5500] text-white" : "text-[#A1A1AA] hover:bg-[#1E1F22] hover:text-white"}`}>
              <l.icon className="h-4 w-4" /> {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-[#27272A] p-3">
          <a href="/" target="_blank" rel="noopener noreferrer" className="mb-1 flex items-center gap-3 px-3 py-2.5 text-sm text-[#A1A1AA] hover:text-white"><ExternalLink className="h-4 w-4" /> Ver site</a>
          <button data-testid="admin-logout" onClick={() => { logout(); navigate("/admin/login"); }} className="flex w-full items-center gap-3 px-3 py-2.5 text-sm text-[#A1A1AA] hover:text-white"><LogOut className="h-4 w-4" /> Sair</button>
        </div>
      </aside>
      <div className="flex-1 overflow-x-hidden">
        <div className="flex items-center justify-between border-b border-[#27272A] bg-[#0A0A0B] px-6 py-3 md:hidden">
          <span className="font-heading font-black text-white">GLOBAL Admin</span>
          <button onClick={() => { logout(); navigate("/admin/login"); }}><LogOut className="h-5 w-5 text-[#A1A1AA]" /></button>
        </div>
        <div className="p-6">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
